import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../../actions/commonActions";
import { FETCH_MEETING_PREPS_FAILURE, FETCH_MEETING_PREPS_REQUEST, FETCH_MEETING_PREPS_SUCCESS } from "../../actions/meetingPrep/meetingPrepsActions";

  const initialState = {
    meetingPrepsLoading: true,
    meetingPrepsData: [],
    meetingPrepsError: null,
  };
  
  const meetingPrepsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_MEETING_PREPS_REQUEST:
        return { ...state, meetingPrepsLoading: true , payload: action.payload};
      case FETCH_MEETING_PREPS_SUCCESS:
        return { ...state, meetingPrepsLoading: false, meetingPrepsData: action.payload };
      case FETCH_MEETING_PREPS_FAILURE:
        return { ...state, meetingPrepsLoading: false, meetingPrepsError: action.payload };    
      case RESET_ALL_ACCOUNT_STATE_DEPEN:
              return initialState        
      default:
        return state;
    }
  };
  
  export default meetingPrepsReducer;
  
